import { transition } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/primeng';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyCardHomingService } from '../../../services/loyalty/loyalty-card-homing.service';

@Component({
  selector: 'app-loyalty-card-homing',
  templateUrl: './loyalty-card-homing.component.html',
  styleUrls: ['./loyalty-card-homing.component.css']
})
export class LoyaltyCardHomingComponent implements OnInit {
  columnsTitles: any;
  baseUrl = '/koncentro-loyalty/cards/';
  selectFilter = KontableComponent.SelectFilter;
  customFilter = KontableComponent.CustomFilter;
  paginationType = KontableComponent.ServerPagination;
  newDataAvailable = false;
  translations = {}

  constructor(
    private translate: TranslateService,
    public cardHomingService: LoyaltyCardHomingService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService) { }

  reloadList() {
    this.newDataAvailable = false;
    this.cardHomingService.list().subscribe( () => {
      this.newDataAvailable = true;
    });
  }

  readyDeployHoming(id) {
    this.confirmationService.confirm({
      header: this.translations['deployHomingTitle'],
      message: this.translations['deployHomingMsg'],
      accept: () => {
        this.cardHomingService.readyDeploy(id).subscribe(() => {
          this.reloadList();
        });
      }
    });
  }

  resetDeployHoming(id) {
    this.cardHomingService.resetDeploy(id).subscribe(() => {
      this.reloadList();
    });
  }

  ngOnInit() {

    this.translate.get([
      'cardHoming.id',
      'cardHoming.card_id',
      'cardHoming.card_no',
      'cardHoming.card_no_start',
      'cardHoming.card_no_end',
      'cardHoming.store_from',
      'cardHoming.store_to',
      'cardHoming.flg_dpl',
      'cardHoming.confirm_deploy_title',
      'cardHoming.confirm_deploy_message',
      'cardHoming.deployHomingTitle',
      'cardHoming.deployHomingMsg'
    ]).subscribe((translations) => {
      this.columnsTitles = {
        id: translations['cardHoming.id'],
        card_id: translations['cardHoming.card_id'],
        card_no: translations['cardHoming.card_no'],
        card_no_start: translations['cardHoming.card_no_start'],
        card_no_end: translations['cardHoming.card_no_end'],
        store_from: translations['cardHoming.store_from'],
        store_to: translations['cardHoming.store_to'],
        flg_dpl: translations['cardHoming.flg_dpl']
      };

      this.translations['confirm_deploy_title'] = translations['cardHoming.confirm_deploy_title'];
      this.translations['confirm_deploy_message'] = translations['cardHoming.confirm_deploy_message'];
      this.translations['deployHomingTitle'] = translations['cardHoming.deployHomingTitle'];
      this.translations['deployHomingMsg'] = translations['cardHoming.deployHomingMsg'];

    });

  }

  operationTypeHandler(event) {
    this.router.navigate(['../card-homing/form'], { queryParams: {operationType: event}, relativeTo: this.activatedRoute });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-homing/loyalty-card-homing.component.ts